import { useContext } from "react";
import Context, {ContextType} from "./Context";
import {BridgeToken} from "../bridge";


export function useBridge(): BridgeToken | undefined {
    const {
        bridge
    } = useContext<ContextType>(Context);
    return bridge;
}